import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup } from "@angular/forms";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import {
  TextTemplate
} from "../../common/models/flow.dto";

import {TextTemplatesService, updateRules} from "../text-templates.service";
import { Observable, Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

import { Rule } from '../../common/models/flow.dto';

@Component({
    selector: 'app-text-template-detail',
    templateUrl: './text-template-detail.component.html',
    styleUrls: ['./text-template-detail.component.scss'],
    standalone: false
})
export class TextTemplateDetailComponent implements OnInit, OnDestroy {

    template:TextTemplate;
    subscription: Subscription = new Subscription();

    editorOptions: any = {
        heightMax: 500,
        height: 500,
        heightMin: 150,
        saveInterval: 0,
        toolbarButtons: ["fullScreen", "html", "undo", "redo", "bold", "italic", "underline", 'strikeThrough', "align", "fontSize", "paragraphFormat", "indent", "color"],
        typingTimer: 150,
        autofocus: true
    }

    contentForm: FormGroup;


    constructor(public readonly _svc:TextTemplatesService, public readonly _route:ActivatedRoute) {

    }

    ngOnInit() {
        let route$ = this._route.params.subscribe(p => {

            if (p["id"] === "new") {
                var item = {
                    id: "NewTemplate",
                    transforms: [],
                    content: ""
                } as TextTemplate;
                this.template = item;
            }
            else {
                console.log("not new");
                this._svc.get(p["id"]).subscribe(t => {
                    this.template = t;
                });
            }
        });
        this.subscription.add(route$);
    }

    ngOnDestroy(){
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    contentFormBuilt(builtForm: FormGroup): void {
        this.contentForm = builtForm;
        const content$ = this.contentForm.get('content').valueChanges.pipe(
            debounceTime(1000), distinctUntilChanged()        )
            .subscribe(
                (c) => {
                    this.template.content = c;
                    this.templateContentChanged();
                },
                (error) => { console.error(error); }
        );
        this.subscription.add(content$);
    }


    save(){
        console.log('save called');
        this._svc.save(this.template.id, this.template).subscribe(x=>this.template = x);
    }

    templateContentChanged() {

        updateRules(this.template);
    }
}

